import { Controller } from '@hotwired/stimulus'
import { handleError } from 'lib/errors'
import { googleAnalytics3Event, googleAnalytics3, sendStandardEvent } from 'lib/googleAnalytics'

export default class extends Controller {
  static values = {
    trackingEnabled: Boolean,
    queryParams: Array
  }

  connect () {
    if (this.trackingEnabledValue) {
      this.logPageView()
      // Changing this "analyticsProcessed" data attribute causes the connect() to fire on each turbo page load
      this.element.dataset.analyticsProcessed = 'true'
    }
  }

  logPageView () {
    // We only want to send certain query strings to Google Analytics (not the entire location.search string).
    // Right now we only want the ?page=X values to go through to GA:
    const allowedQueryParams = this.queryParamsValue

    // This loops over the available search params and builds a new list based on the "allowedQueryParams" above
    const browserSearchParams = new URLSearchParams(window.location.search)
    const searchParamsToLog = new URLSearchParams()
    for (const [searchParam, searchParamValue] of browserSearchParams) {
      if (allowedQueryParams.includes(searchParam)) {
        searchParamsToLog.append(searchParam, searchParamValue)
      }
    }

    // We then stringify any allowed search params and append that to our GA page
    const searchStringToLog = searchParamsToLog.toString()
    const pagePath = `${window.location.pathname}${searchStringToLog.length > 0 ? `?${searchStringToLog}` : ''}`

    googleAnalytics3('set', 'page_path', pagePath)
    googleAnalytics3Event({
      eventAction: 'page_view',
      eventCategory: null,
      eventLabel: null
    })
  }

  trackClick (event) {
    // This is similar to the standardised tracking in Storefront, Elements and Marketplace.
    // As detailed here: https://github.com/envato/standard-analytics
    // We take a global "page id", a "section id" and an "element id" and use that to build the event payload.

    const target = event.target.closest('[data-analytics-element-id]')
    if (!target) return

    const elementId = target.dataset.analyticsElementId
    const elementLabel = target.dataset.analyticsElementLabel
    const section = target.closest('[data-analytics-section-id]')
    if (!section) {
      handleError(`Missing data-analytics-section-id for target ${elementId}`)
      return
    }

    const sectionId = section.dataset.analyticsSectionId
    const sectionLabel = section.dataset.analyticsSectionLabel
    const tagName = target.nodeName?.toLowerCase()

    if (sectionId && elementId && tagName) {
      sendStandardEvent({
        eventType: 'click',
        sectionId,
        sectionLabel,
        elementId,
        elementLabel,
        tagName
      })
    }
  }
}
